export default function (debug = false) {
    return (window.debug || debug) ? window.console : {
        log() {},
        info() {},
        debug() {},
        warn() {}
    };
}



// WEBPACK FOOTER //
// ./static_source/js/console.js